import {Stores} from '../../inject';
import MemoryBar from './MemoryBar';
import {Draggable} from 'react-beautiful-dnd';
import BookmarkItem from './BookmarkItem';
import {HistoryItem as IHistoryItem} from '../../stores/MemoryBarStore';
import React from 'react';
import {observer} from 'mobx-react';
import {AnalyticsTab} from '../../stores/store';
import HistoryItem from './HistoryItem';

export const MemoryBarChooser = observer(({store}: Stores<'store'>) => {
    const {reportEditorStore, activeAnalyticsTab} = store;
    if (reportEditorStore.reportEditing.editorIsActive && activeAnalyticsTab === AnalyticsTab.ReportView) {
        return <ReportMemoryBar store={store} />;
    }
    return <DefaultMemoryBar store={store} />;
});

const itemShouldBeDisabledForReport = (memoryItem: IHistoryItem): boolean => {
    return memoryItem.analyticsTab === AnalyticsTab.CampaignView || memoryItem.compareData !== undefined;
};

const ReportMemoryBar = observer(({store}: Stores<'store'>) => {
    const {memoryBarStore, reportEditorStore, selectorTableStore} = store;
    return (
        <MemoryBar
            activeMemoryTabPackage={{
                get: () => memoryBarStore.activeMemoryBarTab,
                set: memoryBarStore.changeActiveMemoryBarTab,
            }}
            isOpen={() => memoryBarStore.sidebarOpen || reportEditorStore.memoryBarIsOpenThroughReportView()}
            memoryItemConversion={{
                get: () => memoryBarStore.memoryItemConversion,
                set: memoryBarStore.memoryItemConversionOccured,
            }}
            applySearchText={memoryBarStore.setSearchText}
            bookmarkItems={memoryBarStore.filteredBookmarkItems.map((bookmarkItem, index) => (
                <Draggable
                    isDragDisabled={itemShouldBeDisabledForReport(bookmarkItem)}
                    key={bookmarkItem.id}
                    draggableId={bookmarkItem.id}
                    index={index}>
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <BookmarkItem
                                disabled={itemShouldBeDisabledForReport(bookmarkItem)}
                                key={bookmarkItem.id}
                                index={index}
                                memoryItemConversionOccured={memoryBarStore.memoryItemConversionOccured}
                                data={bookmarkItem}
                                degradeBookmarkToHistoryItem={memoryBarStore.degradeBookmarkToHistoryItem}
                                getAttributeNameIfPossible={selectorTableStore.getAttributeNameIfPossible}
                            />
                        </div>
                    )}
                </Draggable>
            ))}
            historyItems={memoryBarStore.filteredHistoryItems.map((historyItem, index) => (
                <Draggable
                    isDragDisabled={itemShouldBeDisabledForReport(historyItem)}
                    key={historyItem.id}
                    draggableId={historyItem.id}
                    index={index}>
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <HistoryItem
                                disabled={itemShouldBeDisabledForReport(historyItem)}
                                key={historyItem.id}
                                index={index}
                                memoryItemConversionOccured={memoryBarStore.memoryItemConversionOccured}
                                data={historyItem}
                                getAttributeNameIfPossible={selectorTableStore.getAttributeNameIfPossible}
                                addBookmarkEntry={memoryBarStore.addBookmarkEntry}
                            />
                        </div>
                    )}
                </Draggable>
            ))}
        />
    );
});

const DefaultMemoryBar = observer(({store}: Stores<'store'>) => {
    const {memoryBarStore, selectorTableStore} = store;
    return (
        <MemoryBar
            activeMemoryTabPackage={{
                get: () => memoryBarStore.activeMemoryBarTab,
                set: memoryBarStore.changeActiveMemoryBarTab,
            }}
            isOpen={() => memoryBarStore.sidebarOpen}
            memoryItemConversion={{
                get: () => memoryBarStore.memoryItemConversion,
                set: memoryBarStore.memoryItemConversionOccured,
            }}
            applySearchText={memoryBarStore.setSearchText}
            bookmarkItems={memoryBarStore.filteredBookmarkItems.map((bookmarkItem, index) => (
                <BookmarkItem
                    key={bookmarkItem.id}
                    index={index}
                    memoryItemConversionOccured={memoryBarStore.memoryItemConversionOccured}
                    data={bookmarkItem}
                    degradeBookmarkToHistoryItem={memoryBarStore.degradeBookmarkToHistoryItem}
                    onClick={memoryBarStore.applyHistoryAndBookmarkSettings}
                    getAttributeNameIfPossible={selectorTableStore.getAttributeNameIfPossible}
                />
            ))}
            historyItems={memoryBarStore.filteredHistoryItems.map((historyItem, index) => (
                <HistoryItem
                    key={historyItem.id}
                    index={index}
                    memoryItemConversionOccured={memoryBarStore.memoryItemConversionOccured}
                    data={historyItem}
                    onClick={memoryBarStore.applyHistoryAndBookmarkSettings}
                    getAttributeNameIfPossible={selectorTableStore.getAttributeNameIfPossible}
                    addBookmarkEntry={memoryBarStore.addBookmarkEntry}
                />
            ))}
            handleOutsideClick={() => memoryBarStore.setSidebarOpen(false)}
        />
    );
});



// WEBPACK FOOTER //
// ./src/views/MemoryBar/ReportDefaultMemoryBar.tsx